<script lang="ts">
	import type { CourseDetail$result } from '$houdini';
	import CourseTrailer from '$lib/components/Course/CourseTrailer.svelte';
	import CloseIcon from '$lib/components/Icon/CloseIcon.svelte';
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';

	export let course: CourseDetail$result['course'];
	export let trailerThumbnail: string = '';

	const showThumbnail: boolean = false;
	const dispatch = createEventDispatcher();
</script>

<div class="sticky top-0 -mt-[86px] left-0 z-[1000]">
	<div
		transition:fade
		on:click={() => dispatch('close')}
		on:keydown={() => dispatch('close')}
		class="h-screen w-screen bg-black/75 absolute"
	>
		<div class="flex flex-col justify-center items-center h-full w-full">
			<button
				on:click|stopPropagation={() => dispatch('close')}
				class="absolute text-white text-3xl top-16 right-[2vw] pt-4"
			>
				<CloseIcon />
			</button>
			<div class="flex flex-col w-full h-full justify-center items-center">
				<CourseTrailer
					additionalClass="!w-3/4"
					elementId="trailer-section"
					trailerUrl={course?.lessons?.[0]?.streamUrl || ''}
					title={course?.lessons?.[0]?.name ?? ''}
					id={course?.lessons?.[0]?.id ?? ''}
					overlayTitle={course?.lessons?.[1]?.name || 'NEXT LESSON'}
					overlayHref={`${course?.slug}/${course?.lessons?.[1]?.slug}` || ''}
					showHeadline={true}
					headlineWhite={true}
					{trailerThumbnail}
					{showThumbnail}
				/>
			</div>
		</div>
	</div>
</div>
